import { ComponentType } from "react";
const DEV_MODE_KEY = "dev-mode";

export const withDevModeComponent = <P extends object>(
  Component: ComponentType<P>,
): ComponentType<P> => {
  const isDevMode = localStorage.getItem(DEV_MODE_KEY) === "true";
  if (!isDevMode) {
    const NullComponent = () => null;
    NullComponent.displayName = `withDevModeComponent(${Component.displayName ?? Component.name ?? "Component"})`;
    return NullComponent;
  }

  return (props: any) => {
    return <Component {...props} />;
  };
};
